import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';
import arrowIcon from '../../../../../images/icons/arrow-up.svg';
import './FreeSamples.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import { freeSamplesObjectsSelector } from '../../../selectors/free_samples';
import skincareIcon from '../../../../../images/icons/skincare.svg';
import FreeSample from './FreeSample';
import { freeSamplesActions } from '../../../actions';

function FreeSamples(props) {
  const [expanded, setExpanded] = useState(true);

  const toggle = () => setExpanded((prevExpanded) => !prevExpanded);

  const {
    freeSamples, uneditable, freeSamplesTitle, addFreeSample, removeFreeSample,
  } = props;

  const filteredFreeSamples = uneditable
    ? freeSamples.filter((freeSample) => freeSample.selected)
    : freeSamples;

  if (filteredFreeSamples.length === 0) {
    return null;
  }

  return (
    <div className={classNames('free-samples', { active: expanded })}>
      <ClickableDiv
        className="toggle"
        onClick={toggle}
      >
        <div className="title">
          <img src={skincareIcon} alt="free samples" />
          {`${freeSamplesTitle} ${uneditable ? '' : '(Pick 1)'}`}
        </div>
        <div className="arrow">
          <img src={arrowIcon} alt="arrow" width="14px" />
        </div>
      </ClickableDiv>
      <AnimateHeight
        duration={400}
        height={expanded ? 'auto' : 0}
        className="products-container"
      >
        { filteredFreeSamples.map((freeSample) => (
          <FreeSample
            key={freeSample.id}
            freeSample={freeSample}
            uneditable={uneditable}
            addFreeSample={addFreeSample}
            removeFreeSample={removeFreeSample}
          />
        ))}
      </AnimateHeight>
    </div>
  );
}

FreeSamples.propTypes = {
  freeSamples: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  uneditable: PropTypes.bool,
  freeSamplesTitle: PropTypes.string.isRequired,
  addFreeSample: PropTypes.func.isRequired,
  removeFreeSample: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  freeSamples: freeSamplesObjectsSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  addFreeSample: (id) => dispatch(freeSamplesActions.addFreeSampleRequest({ id })),
  removeFreeSample: (id) => dispatch(freeSamplesActions.removeFreeSampleRequest({ id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(FreeSamples);
